import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import Button from '@magalu/stereo-ui/atoms/Button';
import { themeGet } from '@magalu/stereo-ui-styles';
export var SharedBagButton = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  font-size: ", "px;\n"])), function (props) {
  return themeGet('palette.background.white')(props);
}, function (props) {
  return themeGet('fontSizes.0')(props);
});